import "../../style/mobile/store/M_Store.scss";
import icon1 from "../../../assets/mobile/store/vuesax-linear-bag-happy.svg";
import MHSearch from "../home/MH_Search";
import MSFilter from "./MS_Filter";
import MAmazingOffer from "../home/M_AmazingOffer";
import MSProducts from "./MS_Products";

const M_Store = () => {
  return (
    <div className="M_Store">
      <div className="M_Store-title-box">
        <img src={icon1} alt="bag-icon" className="M_Store-title-box-icon" />
        <div className="M_Store-title-box-text">فروشگاه آزمون‌ها</div>
      </div>
      <MHSearch />
      <MSFilter />
      <MAmazingOffer />
      <MSProducts />
    </div>
  );
};

export default M_Store;
